import { Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from 'src/app/services/helpers/helpers.service'

@Component({
	selector: 'app-insurances',
	templateUrl: './insurances.component.html',
	styleUrls: ['./insurances.component.scss'],
})
export class InsurancesComponent implements OnInit {
	constructor(
        public helpers: HelpersService,
        private route: ActivatedRoute,
    ) {}
    showTestText: boolean = false;

	ngOnInit(): void {
        this.showTestText = this.route.snapshot.url.join('/').includes('teste')
    }
	@Input() classCustom: string
	@Input() data: any
}
